import { css } from '@emotion/react';

import { NAVIGATION_BREAKPOINTS } from './constants';

/**
 * Hides content when mobile navigation is active.
 */
export const hideOnMobileNavigationStyles = css({
  [NAVIGATION_BREAKPOINTS.MOBILE]: {
    display: 'none',
  },
});

/**
 * Hides content when desktop navigation is active.
 */
export const hideOnDesktopNavigationStyles = css({
  [NAVIGATION_BREAKPOINTS.DESKTOP]: {
    display: 'none',
  },
});
